import React, { FC, useContext } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PeriodCalendar from '@components/common/periodCalendar';
import styles from '@components/jobs/jobs.module.scss';
import { CalendarContext } from '@components/jobs/contextWrap';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface MiniCalendarProps {
  setIsFocusDate: (isFocus: boolean) => void;
}

const MiniCalendar: FC<MiniCalendarProps> = ({ setIsFocusDate }) => {
  const { calendarInfo, miniCalendarInfo, filter } = useContext(CalendarContext);
  const { getValues } = useFormContext<CalendarFilterFormVO>();
  const { field: targetMonthField } = useController({ name: 'targetMonth' });

  //미니캘린더 날짜 선택시 실행
  const handleChange = (date: Date) => {
    setIsFocusDate(true);
    miniCalendarInfo.setSelectedDate(date);
    calendarInfo.setCalendarDate(date);
    const newTargetMonth = DateFormat.format(date, 'yyyy-MM');
    targetMonthField.onChange(newTargetMonth);
    filter.setLatestFilter({ ...getValues(), targetMonth: newTargetMonth });
  };

  //오전 12시 공고 마감이면 이전날짜로 표시해줘야함
  const getModifyClosingDateTime = (closingDateTime: string) => {
    const newClosingDateTime = new Date(closingDateTime);
    const closingHour = newClosingDateTime.getHours();
    const closingMinute = newClosingDateTime.getMinutes();

    if (closingHour === 0 && closingMinute === 0) {
      newClosingDateTime.setDate(newClosingDateTime.getDate() - 1);
    }

    return newClosingDateTime;
  };

  return (
    <div className={cx('miniCalendarArea')}>
      <div className={cx('miniCalendarInner')}>
        <PeriodCalendar
          selected={miniCalendarInfo.selectedDate}
          onChange={handleChange}
          placeholderText="연도. 월. 일"
          maxDate={new Date('9999-12-31')}
          startDate={miniCalendarInfo.startDate ? new Date(miniCalendarInfo.startDate) : null}
          endDate={miniCalendarInfo.endDate ? getModifyClosingDateTime(miniCalendarInfo.endDate) : null}
        />
      </div>
    </div>
  );
};

export default MiniCalendar;
